// extracted by mini-css-extract-plugin
export default {"valueErr":"src-components-ErrorNotice-css__valueErr--UMqfm"};